import { DesBaseCollabAcc } from './des-base-collab-acc';
export class DesBaseRfqQuote extends DesBaseCollabAcc {

    constructor(ViewModel) {
        super(ViewModel);
        this.ViewModel = ViewModel;
    }

    getProps() {
        return {
            collaborationspaceid: this.collaborationspaceid,
            rfqquoteid: this.rfqquoteid
        };
    }

    get collaborationspaceid() {
        return this.getAttribute('collaborationspaceid') || this.getAttribute('collaborationspace-id');
    }

    get rfqquoteid() {
        return this.getAttribute('rfqquoteid') || this.getAttribute('rfq-quote-id');
    }

    static get observedAttributes() {
        return [ ...DesBaseCollabAcc.observedAttributes, 'collaborationspaceid', 'collaborationspace-id', 'rfqquoteid', 'rfq-quote-id' ];
    }
}
